/* Change password required component */
import * as _ from 'lodash';
import * as React from 'react';
import { Button, Row, Well } from 'react-bootstrap';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { push } from 'react-router-redux';
import { compose } from 'redux';
import { connectRequest } from 'redux-query';

import * as MutateActions from '../actions/mutate';
import Auth from '../auth/auth';
import * as AppComp from '../common/app-component-base';
import { BootstrapColXl as Col } from '../common/bootstrap/bootstrapcolxl';
import { Formatters } from '../common/formatters';
import * as KendoWrappers from '../common/kendoforms/componentwrappers';
import { EmailLinkComponent, NavigationLinks } from '../common/navigation';
import * as UserComponents from '../common/user-components';
import ApiEndpoints from '../config/apiendpoints';
import AppConfiguration from '../config/configuration';
import * as ReduxQueries from '../queries';

export interface IChangePasswordLoginProps extends AppComp.IAppComponentProps {
  changePasswordUserDetail?: any;
  userObjId?: any;
  activateUser?: any;
  navigateTo?: any;
}

export interface IChangePasswordLoginState extends AppComp.IAppComponentState {
  formChanges?: any;
}

class ChangePasswordLogin extends AppComp.AppComponent<IChangePasswordLoginProps, IChangePasswordLoginState> {
  public originalFormDataCache = {};

  public constructor(props: IChangePasswordLoginProps) {
    super(props, 'app.user-change-password.');

    this.state = {
      formChanges: {},
    };
  }

  public componentDidUpdate() {
    let resetFormData = this.getFormChangesResetRequired();

    if (resetFormData && _.size(this.state.formChanges)) {
      this.setState({ formChanges: {} });
    }
  }

  // handler
  public handleUpdateAccountButton(e: any) {
    const token = 'NO-TOKEN';

    const changeData = _.merge(
      {},
      {
        _id: Formatters.getStr(this.props, 'changePasswordUserDetail._id'),
      },
      this.state.formChanges
    );

    // console.log('handleLoginButton changeData', changeData);

    this.props.activateUser(changeData, token, false).then(response => {
      // We can promise-chain on the mutation action to trigger state
      // transitions when it succeeds or fails.

      if (response.status >= 200 && response.status < 300) {
        this.originalFormDataCache = {};
        this.setState({ formChanges: {} });

        const auth = new Auth();
        const logoutRedirectToUrlOnLogin = NavigationLinks.userDashboard();
        auth.logout(logoutRedirectToUrlOnLogin);

        // this.props.navigateTo(logoutRedirectToUrlOnLogin);
      } else {
        // Error during creation...
      }
    });
  }

  public handleFormInputChange(e: any, x: any) {
    // console.log('handleForminputchange', {e: e, x: x });

    const getChangesResult = this.getFormChanges(e, x);
    // console.log('handleForminputchange getChangesResult', {getChangesResult: getChangesResult, e: e, x: x });
    if (getChangesResult.applyChanges) {
      this.setState({
        formChanges: getChangesResult.formChanges
      });
    }
  }

  public getFormChanges(e: any, x: any) {
    let result = {
      applyChanges: false,
      formChanges: {},
      formChangesResult: {},
    };

    let fieldName = '';
    let newValue;

    let formChangesCopy = _.cloneDeep(this.state.formChanges);

    if (_.get(e, 'target.props.name')) {
      // Kendo form element
      if (_.has(e, 'target.combobox')) {
        // combobox
        fieldName = _.get(e, 'target.props.name', '');
        newValue = _.get(e, 'target.value');
      } else {
        // assume textbox
        fieldName = _.get(e, 'target.props.name', '');
        newValue = _.get(e, 'value');
      }
    } else {
      const eventTargetType = _.get(e, 'target.type', '');

      switch (eventTargetType) {
        case 'textarea':
        case 'text':
        case 'email':
        case 'password':
          fieldName = _.get(e, 'target.name', '');
          newValue = _.get(e, 'target.value');
          break;

        case 'kendo-dropdownlist':
          fieldName = _.get(e, 'target.name', '');
          newValue = _.get(e, 'target.value', '');
          break;

        case 'virtualized-select':
          fieldName = _.get(e, 'target.name', '');
          newValue = _.get(x, 'value');
          break;

        case 'delete-button':
          fieldName = _.get(e, 'target.name', '');
          newValue = _.get(e, 'target.value');
          break;

        default:
          console.log(`*** handleFormInputChange switch hit default for eventTargetType ${eventTargetType}`);
          break;
      }
    }

    // console.log(`handleFormInputChange continuing 1 fieldName ${fieldName} newValue ${newValue}`, { e: e, x: x });

    if (!fieldName) { return result; }

    let applyChange = false;
    let origVal = _.get(this.originalFormDataCache, fieldName);
    let formChangesResult = {};
    if (_.isArray(origVal)) {
      if (_.isArray(newValue)) {
        if (!_.isEqual(origVal, newValue)) {
          _.set(formChangesCopy, fieldName, _.cloneDeep(newValue));
          _.set(formChangesResult, fieldName, _.cloneDeep(newValue));
          applyChange = true;
        } else {
          applyChange = false;
        }
      } else {
        if (_.includes(origVal, newValue)) {
          // console.log(`original array already contained val ${newValue} origVal`, origVal);
          applyChange = false;
        } else {
          const formChangesArr = _.get(formChangesCopy, fieldName, []);
          // console.log(`${fieldName} formChangesArr`, formChangesArr);
          if (_.includes(formChangesArr, newValue)) {
            // console.log(`formChangesArr field ${fieldName} array already contains val ${newValue} formChangesArr`, formChangesArr);
            applyChange = false;
          } else {
            formChangesArr.push(newValue);
            _.set(formChangesCopy, fieldName, _.cloneDeep(formChangesArr));
            _.set(formChangesResult, fieldName, _.cloneDeep(formChangesArr));
            applyChange = true;
            // console.log(`formChangesArr field ${fieldName} array DID NOT have val ${newValue}, applying change`, formChangesArr);
          }
        }
      }
    } else {
      // if (String(newValue) !== String(origVal)) {
      // New value
      _.set(formChangesCopy, fieldName, newValue);
      _.set(formChangesResult, fieldName, newValue);
      applyChange = true;
      // } else {
      //     // Same as orig val
      //     if (_.has(formChangesCopy, fieldName)) {
      //         _.unset(formChangesCopy, fieldName);
      //         _.set(formChangesResult, fieldName, newValue);
      //         applyChange = true;
      //     }
      // }
    }

    if (applyChange) {
      result.applyChanges = true;
      result.formChanges = _.cloneDeep(formChangesCopy);
      result.formChangesResult = _.cloneDeep(formChangesResult);
    }

    // console.log(`getFormChanges returns result`, result);

    return result;
  }

  public getFormData(userIn: any) {
    const user = _.merge({}, userIn, this.state.formChanges);

    let result = {
      username: Formatters.getStr(user, 'email'), // Formatters.getStr(user, 'username'),

      password: Formatters.getStr(user, 'password'),
      newPassword: Formatters.getStr(user, 'resetPassword'),
      newPasswordConfirm: Formatters.getStr(user, 'resetPasswordConfirm'),

      passwordChangeRequired: Formatters.getBool(user, 'passwordChangeRequired'),
    };

    const res = _.merge({}, result, this.state.formChanges);

    // console.log(`change-password-login::getFormData res`, { res });

    return res;
  }

  public getFormChangesCount() {
    return _.size(this.state.formChanges);
  }

  public getFormChangesResetRequired() {
    let resetFormData = false;
    // Props values
    const pa = Formatters.getStr(this.props, 'userObjId');

    // Cached values
    const ca = Formatters.getStr(this.originalFormDataCache, 'userObjId');

    // Determine if formdata state and cache needs reset due to changing associd or invid
    if (pa && ca) {
      resetFormData = (pa !== ca) ? true : false;
    }

    return resetFormData;
  }

  public renderSectionEnterPassword = (formData: any) => {
    const defaultInputProps = { colLabelXs: 4, colInputXs: 4 };

    let inputPropsFullWidthTextDebounced = _.merge({}, defaultInputProps, {
      handleChange: (n, v) => { this.handleFormInputChange(n, v); },
      className: 'inventory-detail-input-full-width',
    });

    let result = (
      <KendoWrappers.KendoFormSectionTitled title={this.appText('enter-your-password')}>
        <KendoWrappers.KendoDisabledInputHidden
          name="username"
          label={this.appText('username')}
          value={Formatters.getStr(formData, 'username')}
          {...inputPropsFullWidthTextDebounced}
        />

        <KendoWrappers.KendoTextInputDebounced
          name="password"
          label={this.appText('password')}
          type="password"
          required={true}
          value={Formatters.getStr(formData, 'password')}
          {...inputPropsFullWidthTextDebounced}
        />
      </KendoWrappers.KendoFormSectionTitled>
    );

    return result;
  }

  public isPasswordValid = (formData: any): boolean => {
    const password = Formatters.getStr(formData, 'password');

    return (password && UserComponents.IsPasswordValid(password)) ? true : false;
  }

  public isNewPasswordValid = (formData: any): boolean => {
    const newPassword = Formatters.getStr(formData, 'newPassword');

    return (newPassword && UserComponents.IsPasswordValid(newPassword)) ? true : false;
  }

  public hasNewPasswordOrConfirmPassword = (formData: any): boolean => {
    const newPassword = Formatters.getStr(formData, 'newPassword');
    const newPasswordConfirm = Formatters.getStr(formData, 'newPasswordConfirm');

    return (newPassword || newPasswordConfirm) ? true : false;
  }

  public isNewPasswordConfirmValid = (formData: any): boolean => {
    const newPassword = Formatters.getStr(formData, 'newPassword');
    const newPasswordConfirm = Formatters.getStr(formData, 'newPasswordConfirm');

    return ((newPassword && newPasswordConfirm) && UserComponents.DoPasswordsMatch(newPassword, newPasswordConfirm)) ? true : false;
  }

  public renderNewPasswordValidation = (formData: any) => {
    const defaultInputProps = { colLabelXs: 4, colInputXs: 6 };
    const isValid = this.isNewPasswordValid(formData);
    const hasPasswords = this.hasNewPasswordOrConfirmPassword(formData);

    const result = (hasPasswords && !isValid) ? (
      <KendoWrappers.ValidationErrorMessage defaultInputProps={defaultInputProps}>
        <span>{this.appTextCommon('forms.validation.password-min-length', 'app.common.', false, String(UserComponents.MinimumPasswordLength))}</span>
      </KendoWrappers.ValidationErrorMessage>
    ) : (<div />);

    return result;
  }

  public renderNewPasswordConfirmValidation = (formData: any) => {
    const defaultInputProps = { colLabelXs: 4, colInputXs: 6 };
    const isValid = this.isNewPasswordConfirmValid(formData);
    const hasPasswords = this.hasNewPasswordOrConfirmPassword(formData);

    const result = (hasPasswords && !isValid) ? (
      <KendoWrappers.ValidationErrorMessage defaultInputProps={defaultInputProps}>
        <span>{this.appTextCommon('forms.validation.passwords-mismatched')}</span>
      </KendoWrappers.ValidationErrorMessage>
    ) : (<div />);

    return result;
  }

  public renderSectionChangePassword = (formData: any) => {
    const defaultInputProps = { colLabelXs: 4, colInputXs: 4 };

    let inputPropsFullWidthTextDebounced = _.merge({}, defaultInputProps, {
      handleChange: (n, v) => { this.handleFormInputChange(n, v); },
      className: 'inventory-detail-input-full-width',
    });

    let result = (
      <KendoWrappers.KendoFormSectionTitled title={this.appText('create-new-password')}>
        <KendoWrappers.KendoTextInputDebounced
          name="newPassword"
          label={this.appText('new-password')}
          type="password"
          required={true}
          value={Formatters.getStr(formData, 'newPassword')}
          {...inputPropsFullWidthTextDebounced}
        />

        {this.renderNewPasswordValidation(formData)}

        <KendoWrappers.KendoTextInputDebounced
          name="newPasswordConfirm"
          label={this.appText('new-password-confirm')}
          type="password"
          required={true}
          value={Formatters.getStr(formData, 'newPasswordConfirm')}
          {...inputPropsFullWidthTextDebounced}
        />

        {this.renderNewPasswordConfirmValidation(formData)}
      </KendoWrappers.KendoFormSectionTitled>
    );

    return result;
  }

  public renderSupportEmailLink = (hideIcon: boolean = true) => {
    const supportEmail = AppConfiguration.getSupportEmail();

    return (supportEmail) ? (
      <EmailLinkComponent
        email={supportEmail}
        hideIcon={hideIcon}
        caption={`${this.appTextCommon('contacts.send-email-to')} ${supportEmail}`}
      />) : undefined;
  }

  public render() {
    const { userObjId, changePasswordUserDetail: user, ...rest } = this.props;

    let page = (<div />);

    if (Formatters.getStr(user, '_id') !== userObjId) { return page; }

    const formData = this.getFormData(user);

    if (this.getFormChangesResetRequired() || !_.size(this.originalFormDataCache)) {
      this.originalFormDataCache = _.cloneDeep(formData);
    }

    const showChangePassword = true; // Formatters.getBool(formData, 'passwordChangeRequired');
    const sectionChangePassword = (showChangePassword) ? (
      <div className="activate-form-section">
        {this.renderSectionChangePassword(formData)}
      </div>) : (<div />);

    const passwordValid = this.isPasswordValid(formData);
    const newPasswordValid = (showChangePassword) ? this.isNewPasswordValid(formData) : true;
    const newPasswordsMatch = (showChangePassword) ? this.isNewPasswordConfirmValid(formData) : true;
    const isFormValid = (passwordValid && newPasswordValid && newPasswordsMatch) ? true : false;

    let instructions = `${this.appText('instructions-1')} ${this.appText('instructions-2')} `;
    instructions += `${this.appText('instructions-3')} `;

    page = (
      <Well className="activate-login-well">
        <Row className="activate-login-panel">
          <Col xs={12}>
            <div className="activate-login-header">
              <h1>{this.appText('change-your-password')}</h1>
            </div>

            <div className="activate-login-text">
              <p>{instructions} {this.renderSupportEmailLink()}.</p>
            </div>

            <div>
              <div className="activate-form-section">
                {this.renderSectionEnterPassword(formData)}
              </div>

              {sectionChangePassword}
            </div>

            <div className="activate-login-button-container">
              <Row>
                <Col xs={2} />
                <Col xs={8}>
                  <Button
                    bsSize="large"
                    bsStyle="success"
                    disabled={!isFormValid}
                    block={true}
                    onClick={e => { this.handleUpdateAccountButton(e); }}
                  >
                    {this.appText('update-account')}
                  </Button>
                </Col>
                <Col xs={2} />
              </Row>
            </div>
          </Col>
        </Row>
      </Well>
    );

    return page;
  }
}

const getApiUrl = props => ApiEndpoints.getUserActivationUrl(Formatters.getStr(props, 'match.params.userObjId'));

const mapPropsToConfigs = (props) => ReduxQueries.Queries.getUserActivationRequest(
  getApiUrl(props),
  'NO-TOKEN',
);

const mapStateToProps = (state, props) => {
  const userObjId = Formatters.getStr(props, 'match.params.userObjId');

  return ReduxQueries.MapQueryStateToPropsByUrl(getApiUrl(props), state, props, {
    changePasswordUserDetail: state.entities.activationUser,
    userObjId: userObjId,
  });
};

const mapDispatchToProps = {
  activateUser: MutateActions.activateUserMutateAsync,
  navigateTo: (path) => push(path),
};

const ChangePasswordLoginContainer = compose<any>(
  connect(mapStateToProps, mapDispatchToProps),
  connectRequest(mapPropsToConfigs)
)(ChangePasswordLogin);

export default withRouter(ChangePasswordLoginContainer);



// WEBPACK FOOTER //
// ./src/user-change-password/change-password-login.tsx